// utils/fileDisplay.ts
import {
  IconFileTypePdf, IconFileTypeDoc, IconFileTypeXls,
  IconFileTypeZip, IconPhoto, IconFile,
} from '@tabler/icons-react';

// ── Icon resolver — maps MIME type to a Tabler file icon ──────────────────
export const getFileIcon = (mimeType?: string | null) => {
  if (!mimeType) return IconFile;
  if (mimeType.startsWith('image/')) return IconPhoto;
  if (mimeType === 'application/pdf') return IconFileTypePdf;
  if (mimeType.includes('word') || mimeType.includes('document')) return IconFileTypeDoc;
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return IconFileTypeXls;
  if (mimeType.includes('zip') || mimeType.includes('compressed')) return IconFileTypeZip;
  return IconFile;
};

// ── Formats an SDK yyyyMMddHHmmss numeric/string timestamp for display ────
export function formatUploadedDate(value: number | string | null | undefined): string {
  const raw = String(value ?? '');
  if (raw.length < 8) return 'Unknown';

  const year   = raw.slice(0, 4);
  const month  = raw.slice(4, 6);
  const day    = raw.slice(6, 8);
  const hour   = raw.slice(8, 10);
  const minute = raw.slice(10, 12);

  const date = `${year}-${month}-${day}`;
  if (raw.length >= 12) return `${date} ${hour}:${minute}`;
  return date;
}